import clsx from "clsx";
import { ReactNode } from "react";

export const ButtonGroupFlexBox = ({
  className,
  primaryButton,
  secondaryButton,
  forceButtonWidth = false,
  rightAligned = false,
}: {
  className?: string;
  primaryButton: ReactNode;
  secondaryButton?: ReactNode;
  forceButtonWidth?: boolean;
  rightAligned?: boolean;
}) => (
  <div
    className={clsx(
      "mt-6 flex flex-col gap-4 tablet:col-span-2 tablet:mt-10 tablet:flex-row-reverse",
      rightAligned
        ? "tablet:justify-start tablet:gap-4"
        : "tablet:justify-between",
      forceButtonWidth &&
        "[&>a]:w-full tablet:[&>a]:w-fit [&>button]:w-full tablet:[&>button]:w-fit [&>div>a]:w-full tablet:[&>div>a]:w-fit [&>div>button]:w-full tablet:[&>div>button]:w-fit",
      className,
    )}
  >
    {primaryButton}
    {secondaryButton}
  </div>
);
